import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { TitleChart } from '../../../../common/inventory/components/TitleChart';
import { InventoryDataExtractor } from '../../../../common/inventory/extractors/InventoryDataExtractor';
import { InventoryCategory } from '../../../../common/inventory/models/InventoryCategory';
import { InventoryRecap } from '../../../../common/inventory/models/InventoryRecap';
import { TABLE_LAYOUT_SX } from '../../constants/constants';

type Props = {
  inventory: InventoryRecap;
};

const CHART_PROPS = { loading: false, initialLoad: false, disableAnimation: true } as const;

const isInventoryCategory = (c: InventoryCategory | null): c is InventoryCategory => {
  return c !== null && c instanceof InventoryCategory;
};

const extractInventoryRows = (inventory: InventoryRecap, columns: number): InventoryCategory[][] => {
  const extractor = new InventoryDataExtractor();
  const { keyStores, hashFunctions, mac, symmetricAlgorithms, asymmetricAlgorithms, operations, keys } = extractor.extractInventoryElements(inventory);

  const charts: InventoryCategory[] = [...(keys ?? []), operations, symmetricAlgorithms, asymmetricAlgorithms, keyStores, hashFunctions, mac].filter(
    isInventoryCategory
  );

  const chunks: InventoryCategory[][] = [];
  for (let i = 0; i < charts.length; i += columns) {
    const chunk = charts.slice(i, i + columns);
    chunks.push(chunk);
  }

  return chunks;
};

export const Inventory = ({ inventory }: Props) => {
  // Extract the inventory charts in rows of two columns each
  const rows = extractInventoryRows(inventory, 2);

  return (
    <Table data-print="table-layout" sx={TABLE_LAYOUT_SX}>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((chart, columnIndex) => (
              <TableCell key={`${rowIndex}_${columnIndex}`}>
                <TitleChart category={chart} title={chart.getName()} {...CHART_PROPS} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
